import { LicenseManager } from 'ag-grid-enterprise';

const AG_GRID_LICENSE_KEY = import.meta.env.VITE_AG_GRID_LICENSE_KEY
  || 'Using_this_{AG_Grid}_Enterprise_key_{AG-100963}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Donnelley_Financial,_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{4}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_June_2027}____[v3]_[01]_MTgxMzYxODgwMDAwMA==8864c8cfb65bec5909273762f4fdc45f';

let agGridLicenseInitialized = false;

export const initializeAgGridLicense = () => {
  if (agGridLicenseInitialized || !AG_GRID_LICENSE_KEY) {
    return;
  }

  LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
  agGridLicenseInitialized = true;
};
